import React from 'react';

import { NuggetVideo } from '@backrs_ui/common-ui/src/molecules/Nugget/NuggetVideo';
import { GUIDE_TEXT_MAX_WIDTH } from '@backrs_ui/grow-ui/src/components/GuidePage';
import type { InternshipGuideAdviceFromAPro } from '@backrs_ui/grow-ui/src/pages/InternshipGuide/content/types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type AdviceFromAProSectionProps = Readonly<{
  content: InternshipGuideAdviceFromAPro;
}>;

export const AdviceFromAProSection: React.FC<AdviceFromAProSectionProps> = ({ content }) => {
  return (
    <Box sx={containerSx}>
      <Typography variant="text-md-regular" sx={introSx}>
        {content.intro}
      </Typography>

      <Box sx={videoWrapperSx}>
        <NuggetVideo variant={{ type: 'LARGE', url: content.videoUrl }} />
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  pb: backrs.spacing['spacing-5xl'],
});

const introSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  mb: backrs.spacing['spacing-3xl'],
  maxWidth: GUIDE_TEXT_MAX_WIDTH,
});

const videoWrapperSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: '720px',
};
